module.exports = __webpack_public_path__ + "img/ja.fa9859cb.svg";